import { formatNumber } from '@/lib/formatter';
import { getDeprecatedEventLabel } from '../utils/mapHelper';

const dateCell = (key, dateFormat) => ({
  key,
  formatter: (row) => (row[key] ? dateFormat(row[key]) : '-')
});

const satangCell = (key, { fallback } = {}) => ({
  key,
  formatter: (row) => {
    const value = row[key];
    if (!value) return fallback ?? formatNumber(0, 0);
    return formatNumber(value / 100, 0);
  }
});

const defaultFormatter = (key) => (row) => row[key] || '-';

export function buildTransferHomeHeaders(dateFormat) {
  const headers = [
    { label: "วันที่บันทึกรายการ (RJ)", width: '130px', ...dateCell('created_at', dateFormat) },
    { label: "วันที่บันทึกรายการ (SC Sales)", width: '160px', ...dateCell('sc_sale_date', dateFormat) },
    { label: "วันที่โอนกรรมสิทธิ์", width: '120px', ...dateCell('transfer_date', dateFormat) },
    { label: "บริษัท (รหัส)", key: 'company_code', width: '80px' },
    { label: "โครงการ", key: 'project_code', width: '90px' },
    { label: "Unit", key: 'unit_no', width: '100px' },
    { label: "บ้านเลขที่", key: 'home_address_no', width: '100px' },
    {
      label: "มูลค่าบ้านสุทธิ (บาท)",
      key: 'net_price',
      width: '130px',
      formatter: ({ net_price: netPrice }) => formatNumber(netPrice, 0)
    },
    { label: "จำนวน MNC 1% จากราคา", width: '140px', ...satangCell('mnc_coin_amount') },
    { label: "มูลค่า MNC (บาท)", width: '115px', ...satangCell('mnc_coin_value') },
    { label: "วันที่ได้รับ MNC", width: '100px', ...dateCell('mnc_received_date', dateFormat) },
    { label: "จำนวนที่ได้รับ MNC (MNC)", ...satangCell('mnc_received_amount', { fallback: '-' }) },
    { label: "จำนวนได้รับ MNC (บาท)", ...satangCell('mnc_received_value', { fallback: '-' }) },
    {
      label: "Event ที่ได้รับ MNC",
      key: 'mnc_event_name',
      formatter: ({ mnc_event: mncEvent, mnc_event_name: mncEventName }) => (
        mncEventName || getDeprecatedEventLabel(mncEvent)
      )
    },
    { label: "สถานะจาก SC Sale (ปิดโอน/ถอยปิดโอน)", key: 'sc_sale_status', width: '118px' },
    { label: "Transaction Type", key: 'transaction_type', width: '110px' },
    { label: "Transaction Status", key: 'transaction_status', width: '115px' },
    { label: "ชื่อผู้รับ MNC", key: 'mnc_recipient_name' },
    { label: "รหัสอ้างอิงตัวบุคคล", key: 'reference_code' },
    { label: "User ID", key: 'user_id', width: '70px' },
    { label: "วันที่ Expired (นับจากวัน โอน 90 วัน)", width: '130px', ...dateCell('expired_date', dateFormat) },
    { label: "Refund Date", width: '100px', ...dateCell('refund_date', dateFormat) },
  ];

  return headers.map((header) => (
    header.formatter
      ? header
      : { ...header, formatter: defaultFormatter(header.key) }
  ));
}
